import { X } from "lucide-react";
import type { ReactNode } from "react";

interface SlidePanelProps {
  /** Panel content */
  children: ReactNode;
  /** Called when the panel should close */
  onClose: () => void;
  /** Panel title */
  title: string;
}

export function SlidePanel({ title, onClose, children }: SlidePanelProps) {
  return (
    <div className="fixed inset-y-0 right-0 z-50 flex w-full flex-col border-l border-border bg-background shadow-[0_0_15px_0_rgb(0_0_0_/0.1)] sm:w-96 dark:shadow-[0_0_20px_0_rgb(0_0_0_/0.5)]">
      {/* Header */}
      <div className="flex items-center gap-2.5 border-b border-border p-3">
        <button
          className="rounded-full p-1 transition-colors hover:bg-muted"
          onClick={onClose}
          type="button"
        >
          <X className="text-foreground" size={20} />
        </button>
        <h2 className="text-base font-semibold text-foreground">{title}</h2>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">{children}</div>
    </div>
  );
}
